export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-white">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold mb-4">神马视频</h3>
            <p className="text-sm text-secondary-300 leading-relaxed">
              神马视频汇聚西瓜视频免费、菠萝视频、青青草视频等主流平台优质影视资源，提供最新电影、热播电视剧、经典老片及热门综艺的高清在线观看服务。每日更新、免费观影、无需注册。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '热门视频', href: '#media' },
                { label: '影视排行', href: '#ranking' },
                { label: '热门话题', href: '#topics' },
                { label: '最新快讯', href: '#updates' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">影视分类</h3>
            <ul className="space-y-2">
              {['动作大片', '爱情喜剧', '悬疑推理', '科幻冒险', '古装武侠'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    className="text-sm text-secondary-300 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 text-white">合作伙伴</h3>
            <p className="text-sm text-secondary-300 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2026 神马视频 - 西瓜视频免费在线观看 | 菠萝视频青青草视频最新电影电视剧高清全集不缓冲。本站所有内容均为外部平台资源聚合，仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-secondary-400 hover:text-white transition-colors cursor-pointer">
              <i className="ri-arrow-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}